import LandingSelectorController from "~/controllers/landing_selector_controller"

const DESKTOP = "(min-width: 768px)"

export default class extends LandingSelectorController {
  static targets = ["screenshot"]

  selectAuth(event) {
    if (!window.matchMedia(DESKTOP).matches) return

    event.preventDefault()
    this.indexValue = Number(event.params.index)
  }

  indexValueChanged(value, previous) {
    super.indexValueChanged(value, previous)

    let field = null

    this.screenshotTargets.forEach((el) => {
      const index = this.indexFor(el)
      const on = index === value

      el.classList.toggle("landing-screenshot--on", on)
      el.classList.toggle("landing-screenshot--under", index === previous && previous !== value)
      el.inert = !on

      if (on && !field) field = el.querySelector("input:not([type=hidden])")
    })

    if (previous !== undefined) field?.focus()
  }
}
